export default {
  title: '计费单位管理',

  // 搜索筛选区域
  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '单位名称、箱型',
    isContainerUnit: '是否箱型单位',
    isContainerUnitPlaceholder: '选择类型',
    status: '状态',
    statusPlaceholder: '选择状态',
    yes: '是',
    no: '否',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 操作按钮
  actions: {
    addFromLibrary: '新增计费单位',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    enableItem: '启用',
    disableItem: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  // 表格列
  table: {
    unitNameCn: '计费单位名称（中文）',
    unitNameEn: '计费单位名称（英文）',
    isContainerUnit: '是否箱型单位',
    containerType: '箱型',
    status: '状态',
    operation: '操作',
    notSet: '未设置',
    noApplicable: '-'
  },

  // 选择弹窗
  modal: {
    title: '选择计费单位',
    confirmText: '确认添加 ({count})',
    selected: '已选择 {count} 个计费单位，共 {total} 个可选'
  },

  // 确认对话框
  confirm: {
    enableItem: '确定要启用此计费单位吗？',
    disableItem: '确定要禁用此计费单位吗？'
  },

  // 消息提示
  messages: {
    selectToEnable: '请选择要启用的计费单位',
    selectToDisable: '请选择要禁用的计费单位',
    selectToAdd: '请选择要添加的计费单位',
    loadError: '计费单位数据加载失败，请稍后重试',
    searchError: '计费单位搜索失败，请稍后重试',
    platformLoadError: '平台计费单位数据加载失败，请稍后重试',
    associateError: '关联计费单位失败，请稍后重试',
    associateSuccess: '成功新增 {count} 个计费单位',
    statusToggleError: '状态切换失败，请稍后重试',
    statusToggleSuccess: '计费单位已{status}',
    batchEnableError: '批量启用失败，请稍后重试',
    batchEnableSuccess: '已启用 {count} 个计费单位',
    batchDisableError: '批量禁用失败，请稍后重试',
    batchDisableSuccess: '已禁用 {count} 个计费单位'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用',
    yes: '是',
    no: '否'
  }
}